import type { ReactNode } from "react";

export function Box({
  children,
  className = "",
  label,
}: {
  children: ReactNode;
  className?: string;
  label?: string;
}) {
  return (
    <section className={`box ${className}`} aria-label={label}>
      {children}
    </section>
  );
}

export function BoxHeader({ title, children }: { title: ReactNode; children?: ReactNode }) {
  return (
    <div className="flex items-center gap-2.5 border-b border-line-soft px-4 py-3">
      <h2 className="text-sm font-semibold">{title}</h2>
      {children}
    </div>
  );
}

/** A small uppercase section label, as used inside panels. */
export function SectionLabel({ children }: { children: ReactNode }) {
  return <h3 className="text-xs font-semibold tracking-[0.05em] text-faint uppercase">{children}</h3>;
}

/** Read-only JSON or text, as the connector returned it. */
export function CodeBlock({ children, label }: { children: string; label?: string }) {
  return (
    <pre
      aria-label={label}
      className="m-0 overflow-auto bg-well px-4 py-3.5 font-mono text-xs leading-relaxed
                 whitespace-pre-wrap text-code"
    >
      {children}
    </pre>
  );
}

/** A labelled block in a detail panel, with an optional control on the right. */
export function DetailSection({
  title,
  children,
  aside,
}: {
  title: string;
  children: ReactNode;
  aside?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center justify-between">
        <SectionLabel>{title}</SectionLabel>
        {aside}
      </div>
      {children}
    </div>
  );
}
